import 'common/index';
import checkoutPage from '../checkout/checkout-page';
import checkoutContactinfo from '../checkout/checkout-contactinfo';
import checkoutShipping from '../checkout/checkout-shipping';
import checkoutShippingMethod from '../checkout/checkout-shipping-method';
import '../checkout/checkout-payment.scss';
import checkoutPaymentMethod from '../checkout/checkout-payment-method';
import '../checkout/checkout-success-block.scss';
import checkoutSteps from '../checkout/checkout-steps';
import checkoutSummary from '../checkout/checkout-summary';
import '../checkout/cart-item-mini.scss';
import '../checkout/plugin-courier.scss';
import '../checkout/plugin-nocall.scss';

checkoutPage();
checkoutContactinfo();
checkoutShipping();
checkoutShippingMethod();
checkoutPaymentMethod();
checkoutSteps();
checkoutSummary();
